module.exports = __webpack_public_path__ + "static/media/MICROSERVICE_USANDO_STREAMING_PARA_BIGDATA_-_KAFKA_NODEJS_GO_GCP-06.94bd3c6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/microservice/MICROSERVICE_USANDO_STREAMING_PARA_BIGDATA_-_KAFKA_NODEJS_GO_GCP-06.png
// module id = 284
// module chunks = 0